import { useEffect, useState, useContext } from 'react';
import { BreakdownsContext } from './contexts/BreakdownsContext';
import { BreakdownsContextType } from './contexts/BreakdownsContextTypes';
import {
  platformIconsMapping,
} from '../../../utils/platforms';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { Link } from 'react-router-dom';
import { BreakdownsContainer } from '../../../components/BreakdownsContainer/BreakdownsContainer';
import { ReactComponent as VerifiedTwitter } from '../../SourcePage/assets/verifiedTwitter.svg';
import { LoaderSmall } from '../../../components/LoaderSmall/LoaderSmall';
import { mapBotEntityTypes } from '../../../utils/actors';
import { cutString } from '../../../utils/cutString';
import { decodeSourceName } from '../../../utils/decodeURI';
import { useTranslation } from 'react-i18next';
import styles from '../NarrativePage.module.scss';

interface TopBotsProps {
  isClickable?: boolean;
  isShare?: boolean;
}

export const TopBots: React.FC<TopBotsProps> = ({ isShare, isClickable = true }) => {
  const { t } = useTranslation();
  const [topBots, setTopBots] = useState<any | null>(null);
  const botEntityTypes = mapBotEntityTypes(t);

  const {
    inauthenticBehavior,
  } = useContext(BreakdownsContext) as BreakdownsContextType;

  useEffect(() => {
    if (!inauthenticBehavior) return;
    setTopBots(inauthenticBehavior.top_actors || []);
  }, [inauthenticBehavior]);

  return (
    <BreakdownsContainer
      title={t('Top inauthentic behavior accounts')}
      details={false}
      flexGrow={1}
    >
      {inauthenticBehavior ? (
        topBots?.length > 0 ? (
          <div className={styles.breakdownsListMain}>
            {topBots?.map((source: any, index: any) => {
              return (
                <div key={`bots_${index}`} className={styles.listItem}>
                  <div className={styles.info}>
                    <span>{platformIconsMapping[source?.platform]}</span>
                    <span className={styles.title}>
                      {isShare || !isClickable ? (
                        <Tooltip content={source.name} position="bottom">
                          {cutString(decodeSourceName(source.name), 30)}
                        </Tooltip>
                      ) : (
                        <Link to={`/sources/${source.id}`}>
                          <Tooltip content={source.name} position="bottom">
                            {cutString(decodeSourceName(source.name), 30)}
                          </Tooltip>
                          {source?.is_verified ? (
                            <span className={styles.verified}>
                              <VerifiedTwitter />
                            </span>
                          ) : (
                            ''
                          )}
                        </Link>
                      )}
                    </span>
                  </div>
                  <div className={styles.details}>{botEntityTypes[source?.inauthentic_type?.toLowerCase() as keyof typeof botEntityTypes]?.title || ''}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.noDataBreakdowns}>
            {t('There is no data to display')}
          </div>
        )
      ) : (
        <div className={styles.widdgetLoader}>
          <LoaderSmall />
        </div>
      )}
    </BreakdownsContainer>
  );
};
